import { MutationTree } from "vuex";
import { StatisticState } from "./types";

export const mutations: MutationTree<StatisticState> = {
  setSmsStaticGroup: (state, data) => {
    state.smsStatisticGroup = data;
  },
  setSmsStaticDetail: (state, data) => {
    state.smsStaticDetail = data;
  },
  pushSmsStaticDetail: (state, data) => {
    state.smsStaticDetail = state.smsStaticDetail.concat(data);
  },
  setSmsStaticDetailFlag: (state, data) => {
    state.smsStaticDetailFlag = data;
  },
};
